import React from 'react';
import styled from 'styled-components/macro'
import {Link} from "@reach/router";
import PropTypes from "prop-types";

const NoStyleLink = styled(Link)`
    text-decoration:none;
    color: ${props => props.theme.primaryColor};
    cursor: pointer; 
    
    &:hover {
    }
`;
const StyledLink = styled(Link)`
    cursor: pointer; 
`;

const NoStyleRoute = (props) => (
    <NoStyleLink to={props.to} className={props.className}>{props.children}</NoStyleLink>
);


const RoutingLink = (props) => (
    <StyledLink to={props.to} className={props.className}>{props.children}</StyledLink>
);

const StyledExternalLink = styled.a`
    padding-left:0.3rem;
`;
const ExternalLink = (props) => (
    <StyledExternalLink target="_blank" rel="noopener noreferrer" onClick={e => e.stopPropagation()} href={props.to}>{props.displayText}</StyledExternalLink>
);


ExternalLink.defaultProps = {
};

ExternalLink.propTypes = {
    to: PropTypes.string.isRequired,
    displayText: PropTypes.string.isRequired
};
export {NoStyleRoute, RoutingLink, ExternalLink};
